export default __webpack_public_path__ + "static/media/Metamask.db497caf.png";